export enum Roles {
  WEB_ADMIN = 'Web-Admin',
  CHANNEL_PARTNER = 'Channel-Partner',
  DEALER = 'Dealer',
  TECHNICIAN = 'Technician',
}
